import { ZodTypeDef, z } from "zod";
import { FigmaFileStructureNodeBase, FigmaFileStructureOrigin, FigmaFileStructureStatistics } from "../elements";
import { ImportModelBase, ImportModelInputBase } from "./base";

//
// Nodes Import Model
//

export const FigmaFileStructureNodeImportModel: z.ZodType<
  FigmaFileStructureNodeImportModel,
  ZodTypeDef,
  FigmaFileStructureNodeImportModelBaseInput
> = FigmaFileStructureNodeBase.extend({
  children: z.lazy(() => FigmaFileStructureNodeImportModel.array()),
});

type FigmaFileStructureNodeImportModelBaseInput = z.input<typeof FigmaFileStructureNodeBase> & {
  children: FigmaFileStructureNodeImportModelBaseInput[];
};

export type FigmaFileStructureNodeImportModel = z.infer<typeof FigmaFileStructureNodeBase> & {
  children: FigmaFileStructureNodeImportModel[];
};

//
// Structure Import Model
//

const FigmaFileStructureImportModelPart = z.object({
  data: z.object({
    rootNode: FigmaFileStructureNodeImportModel,
    assetsInFile: FigmaFileStructureStatistics,
  }),
});

export const FigmaFileStructureImportModel = ImportModelBase.extend(FigmaFileStructureImportModelPart.shape).extend({
  origin: FigmaFileStructureOrigin,
});

export type FigmaFileStructureImportModel = z.infer<typeof FigmaFileStructureImportModel>;

//
// Import model input
//

export const FigmaFileStructureImportModelInput = ImportModelInputBase.extend(
  FigmaFileStructureImportModelPart.shape
).extend({
  fileVersionId: z.string(),
});

export type FigmaFileStructureImportModelInput = z.infer<typeof FigmaFileStructureImportModelInput>;

export function figmaFileStructureImportModelToMap(
  root: FigmaFileStructureNodeImportModel
): Map<string, FigmaFileStructureNodeImportModel> {
  const map = new Map<string, FigmaFileStructureNodeImportModel>();
  recursiveFigmaFileStructureToMap(root, map);
  return map;
}

function recursiveFigmaFileStructureToMap(
  node: FigmaFileStructureNodeImportModel,
  map: Map<string, FigmaFileStructureNodeImportModel>
) {
  map.set(node.id, node);
  for (const child of node.children) recursiveFigmaFileStructureToMap(child, map);
}
